function setSpinnerStateReducer(currentState = "", action) {
  switch (action.type) {
    case "SET_SPINNER_STATE":
      return action.payload;
    default:
      break;
  }
  return currentState;
}

export default setSpinnerStateReducer;
